export function isVisible(element: HTMLElement) {
  return element.offsetWidth > 0 && element.offsetHeight > 0;
}

export function findVisible(selector: string) {
  return Array.from(document.querySelectorAll<HTMLElement>(selector)).find(
    isVisible,
  );
}
